import { render, staticRenderFns } from "./DFormPlan.vue?vue&type=template&id=1fb62735&scoped=true&"
import script from "./DFormPlan.vue?vue&type=script&lang=js&"
export * from "./DFormPlan.vue?vue&type=script&lang=js&"
import style0 from "./DFormPlan.vue?vue&type=style&index=0&id=1fb62735&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb62735",
  null
  
)

export default component.exports